import React from 'react';
import { makeStyles } from '@material-ui/styles';
import LogoBase from './LogoBase';

const useStyles = makeStyles(() => ({
  logo: {
    height: 48,
    paddingTop: 8,
    paddingRight: 8,
    paddingLeft: 8
  }
}));
const LogoSidebar = () => {
  const classes = useStyles({})
;
  return <LogoBase className={classes.logo} />;
};

export default LogoSidebar;
